import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS } from '../constants/searchParamNames';
import searchSrc from '../assets/search.svg';

const SearchBarTrigger: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClick = () => {
    searchParams.set(SEARCH_PARAMS.SEARCH, 'true');
    searchParams.delete(SEARCH_PARAMS.MENU);
    setSearchParams(searchParams);
  };

  return (
    <>
      <img
        onClick={handleClick}
        className="cursor-pointer"
        src={searchSrc}
        alt="control searchbar"
        height={24}
        width={24}
      />
    </>
  );
};

export default SearchBarTrigger;
